import "./UI/AndarBaharClassic.scss"
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import AndarBaharClassicChipsController from "./UI/AndarBaharClassicChipsController";
import AndarBaharCardContainer from "./UI/AndarBaharCardContainer";

import AndarTitleImg from "../../../../../assets/games/AB_classic_Non_timer/AndarTitle.svg"
import BaharTitleImg from "../../../../../assets/games/AB_classic_Non_timer/BaharTitle.svg"
import infoIcon_img from "../../../../../assets/games/AB_classic_Non_timer/i.svg"
import { changeAmountToFixed } from "../../../Utillitys/changeAmountToFixed";

import betChipSnd from "../../../../../assets/sounds/betoncard.mp3"
import CardFallSnd from "../../../../../assets/sounds/slide.mp3"
import msgSnd from "../../../../../assets/sounds/coindrop_old.mp3"
import clearSnd from "../../../../../assets/sounds/clear.mp3"
import loseSnd from "../../../../../assets/sounds/duplose.mp3"
import pokerChipSnd from "../../../../../assets/sounds/pokerChip.mp3"
import glowSnd from "../../../../../assets/sounds/successNew.mp3"
import invalidBet from "../../../../../assets/sounds/alert.mp3"
import buttonClickSnd from "../../../../../assets/sounds/buttonClick.mp3"

import { Howl } from "howler"
import CardSparkAnimation from "../../../../../library/NewCardWinAnimation/CardSparkAnimation";
import AndarBaharClassicNonTimerInfo from "./UI/AndarBaharClassicNonTimerInfo";
import Card from "../../../../../library/Card/Card";
import useSafeTimeout from "../../../Utillitys/useSafeTimeout";


const AndarBaharClassic = forwardRef((props, ref) => {

    const [orientation, setOrientation] = useState(''); // 'windows', 'portrait', 'landscape'

    const [betAmount, setBetAmount] = useState(0)
    const [duplicateBetAmount, setDuplicateBetAmount] = useState(0)
    const [cardsBet, setCardsBet] = useState({})
    const [andarBet, setAndarBet] = useState(0)
    const [baharBet, setBaharBet] = useState(0)
    const [suitBets, setSuitBets] = useState({
        spade: 0,
        club: 0,
        diamond: 0,
        heart: 0
    })
    const [firstSixBet, setFirstSixBet] = useState(0)
    const [lastSixBet, setLastSixBet] = useState(0)

    const [winAmount, setWinAmount] = useState(0)
    const [winResult, setWinResult] = useState(undefined)

    const [selectedBetChip, setSelectedBetChip] = useState(0)
    const [infoMsg, setInfoMsg] = useState(props.language.AmusementOnly)
    const [betChipsArray] = useState(props.abt_chipValues.split(",").map(ele => (Number(ele) ?? ele)))
    const cardContainerRef = useRef()
    const controllerRef = useRef()
    const [betBtn, setBetBtn] = useState("")
    const [betLimits] = useState(props.abt_innerLimits.split("|"))
    const [showInfoPopUp, setShowInfoPopUp] = useState(false)
    const [showWinAnimation, setShowWinAnimation] = useState(false)
    const [showWinAmount, setShowWinAmount] = useState(false)
    const [disableBets, setDisableBets] = useState(false)
    const [enterPopUp, setEnterPopUp] = useState(true);
    const [isBetSent, setIsBetSent] = useState(false)
    const [disableBetBtn, setDisableBetBtn] = useState(false)
    const [showGameRules, setShowGameRules] = useState(false)
    const soundsRef = useRef({});
    const betRequestTimeOut = useRef(null);
    const showErrorMsgPopUp = useRef(null);
    const isInitial = useRef(true)
    const { setSafeTimeout, cancelTimeout } = useSafeTimeout();

    useImperativeHandle(ref, () => ({
        handleResize,
        checkAndarBaharClassicResult,
        updateGameState,
        updateHistory,
        updatePlayerInfo: () => {
            setDuplicateBetAmount(0)
        },
        dealAndCheckAndarBaharResult,
    }))

    useEffect(() => {
        const unlock = () => {
            if (!soundsRef.current?.cardFallSound) {
                soundsRef.current = {
                    cardFallSound: new Howl({ src: [CardFallSnd], html5: true }),
                    betChipSound: new Howl({ src: [betChipSnd], html5: true }),
                    messageSound: new Howl({ src: [msgSnd], html5: true }),
                    clearSound: new Howl({ src: [clearSnd], html5: true }),
                    lostSound: new Howl({ src: [loseSnd], html5: true }),
                    pokerChipSound: new Howl({ src: [pokerChipSnd], html5: true }),
                    winGlowSound: new Howl({ src: [glowSnd], html5: true }),
                    buttonClick: new Howl({ src: [buttonClickSnd], html5: true }),
                    invalidBet: new Howl({ src: [invalidBet], html5: true }),
                };
            }
            window.removeEventListener("touchstart", unlock);
            window.removeEventListener("click", unlock);
        };

        window.addEventListener("touchstart", unlock, { once: true });
        window.addEventListener("click", unlock, { once: true });
        window.addEventListener('resize', handleResize);
        handleResize(); // initialize
        props.assestsLoaderFunction()
        if (props?.gameState) {
            updateGameState()
        }
        return () => {
            window.removeEventListener('resize', handleResize)
        };
    }, []);

    useEffect(() => {
        if (!isInitial.current) {
            if ((andarBet || baharBet) && (props.gameState.handId === props.gameState.oldHandId || props.andarBaharTimerResult?.action === "PARAM_BET")) {
                setDuplicateBetAmount(changeAmountToFixed(Number(andarBet) + Number(baharBet)), 2)
            } else if (props.gameState.oldHandId !== props.gameState.handId) {
                setDuplicateBetAmount(changeAmountToFixed(betAmount, 2))
            } else {
                setDuplicateBetAmount(0)
            }
        }
    }, [betAmount])

    useEffect(() => {
        if (!isBetSent && !isInitial.current && props.andarBaharTimerResult?.action === "ANDAR_BAHAR_BET") {
            clearAllBets()
        }
    }, [isBetSent])

    useEffect(() => {
        if (!isInitial.current) {

            let newBetAmount = Number(andarBet) + Number(baharBet) + Number(Object.values(cardsBet)[0] ?? 0) + Number(Object.values(suitBets).reduce((a, b) => a + b, 0)) + Number(firstSixBet) + Number(lastSixBet)
            if (newBetAmount) {
                playTheSound("betChipSound");
                if (betBtn !== props.language.BetOK) {
                    setBetBtn(props.language.BetOK)
                }
            }
            else {
                playTheSound("clearSound")
                if ((betBtn === props.language.BetOK && props.andarBaharTimerResult.action === "ANDAR_BAHAR_BET") || (!props.andarBaharTimerResult.action && props.gameState.oldHandId !== props.gameState.handId && props.gameState.betRequest?.betString)) {
                    setBetBtn(props.language.Prev)
                } else {
                    setBetBtn(props.language.BetOK)
                }
            }
            if (!andarBet && !baharBet && (props.gameState.handId === props.gameState.oldHandId || props.andarBaharTimerResult?.action === "PARAM_BET")) {
                setDisableBetBtn(true)
            } else {
                setDisableBetBtn(false)
            }
            setBetAmount(changeAmountToFixed(newBetAmount, 2))
        }
    }, [andarBet, baharBet, cardsBet, suitBets, lastSixBet, firstSixBet])

    useEffect(() => {
        if (!isInitial.current) {
            playTheSound("pokerChipSound")
        }
    }, [selectedBetChip])

    useEffect(() => {
        if (showInfoPopUp && !isInitial.current) {
            cancelTimeout(showErrorMsgPopUp.current);
            showErrorMsgPopUp.current = setSafeTimeout(() => {
                setShowInfoPopUp(false)
            }, 3000)
            playTheSound("invalidBet")
        }
    }, [showInfoPopUp])

    const detectOrientation = () => {
        const isLandscape = window.innerWidth > window.innerHeight;
        if (isLandscape && window.innerWidth >= 1024) return 'windows';
        return isLandscape ? 'landscape' : 'portrait';
    };

    const handleResize = () => {
        setOrientation(detectOrientation());
    };

    const updateGameState = () => {
        setWinAmount(0)
        setIsBetSent(false)

        if (props.gameState?.handId !== 0 && props.gameState?.oldHandId === props.gameState?.handId) {
            // setDuplicateBetAmount(props.gameState.response.betAmount)
            setBetAmount(changeAmountToFixed(props.gameState.response.betAmount, 2))
            cardContainerRef.current?.setIsDealt(true)
            setDisableBets(true)
            playTheSound("cardFallSound")
            setWinAmount(props.gameState.response.winAmount)
            cardContainerRef?.current?.setJokerCard(props.gameState.response.joker)
            const [cardRank, cardSuit, sixSet] = props.gameState.response?.winData
            const [rankBets, suitBets, sixBets] = props.gameState.betRequest?.betString.split(",")
            const [spade, club, diamond, heart] = suitBets.split("|").map(ele => Number(ele))
            const result = {};

            rankBets.split("|").forEach((value, index) => {
                if (value !== "0") {
                    result[index] = Number(value);
                }
            });
            setWinResult({
                rankCard: cardRank,
                suitBet: cardSuit,
                sixSet,
            })
            setSuitBets({
                spade,
                club,
                diamond,
                heart
            })
            setCardsBet({ ...result })
            setFirstSixBet(Number(sixBets.split("|")[0]))
            setLastSixBet(Number(sixBets.split("|")[1]))
        } else {
            // cardContainerRef.current?.setAB_Bets(false)
            // cardContainerRef.current?.setIsDealt(false)
            // cardContainerRef.current?.clearAllCards()
            setDisableBets(false)
            setDuplicateBetAmount(0)
            setBetAmount(0)
        }
        isInitial.current = false
    }

    const checkAndarBaharClassicResult = (res) => {
        clearTimeout(betRequestTimeOut.current);
        cardContainerRef.current?.setAB_Bets(false)
        betRequestTimeOut.current = null;
        //  console.log(res)
        setShowGameRules(false)
        cardContainerRef.current.setIsDealt(true)
        setInfoMsg(props.language.Bet_Accepted + res.betAmount)
        setDisableBetBtn(true)
        setWinAmount(res.winAmount)
        // if (!res.totalWinAmount) {
        //     setIsBetSent(false)
        // }
        // cardContainerRef?.current?.startDealingCards(res)
    }

    const dealAndCheckAndarBaharResult = (res) => {
        clearTimeout(betRequestTimeOut.current);
        betRequestTimeOut.current = null;
        setShowGameRules(false)
        setInfoMsg(props.language.Bet_Accepted + res.betAmount)
        //  console.log(res)
        cardContainerRef?.current?.startDealingCards(res)
    }

    const checkIfTheBetAmountIsValid = (
        rankCardBet = Object.values(cardsBet)[0] || 0,
        andar = andarBet || 0,
        bahar = baharBet || 0,
        suit = 0,
        firstSix = firstSixBet,
        lastSix = lastSixBet,
        totalSuitBet = Object.values(suitBets).reduce((a, b) => a + b, 0)
    ) => {
        const [rankCardMin, rankCardMax] = betLimits[0].split("-").map(Number);
        const [suitsMin, suitsMax] = betLimits[1].split("-").map(Number);
        const [sixMin, sixMax] = betLimits[2].split("-").map(Number);
        const [ABMin, ABMax] = betLimits[3].split("-").map(Number);

        const totalMin = Number(props.minBetAmt);
        const totalMax = Number(props.maxBetAmt);
        const balance = Number(props.balance || 0);
        // const totalSuitBet = Object.values(suitBets).reduce((a, b) => a + b, 0);

        // 🔹 Phase totals
        const phase1Total =
            rankCardBet + suit + totalSuitBet + firstSix + lastSix;

        const phase2Total = andar + bahar;

        const isPhase2 = phase2Total > 0 && phase1Total > 0;

        // ✅ Only validate NEW bets against balance
        const betToValidate = isPhase2 ? phase2Total : phase1Total;

        // ❌ No bet placed
        if (betToValidate === 0) {
            setInfoMsg("Please place at least one bet amount before proceeding.");
            setShowInfoPopUp(true);
            return false;
        }

        // ✅ Individual rules
        const rules = [
            {
                value: rankCardBet,
                min: rankCardMin,
                max: rankCardMax,
                condition: rankCardBet > 0,
                message: `Rank card bet must be between ${rankCardMin} and ${rankCardMax}.`
            },
            {
                value: andar,
                min: ABMin,
                max: ABMax,
                condition: andar > 0,
                message: `Andar bet must be between ${ABMin} and ${ABMax}.`
            },
            {
                value: bahar,
                min: ABMin,
                max: ABMax,
                condition: bahar > 0,
                message: `Bahar bet must be between ${ABMin} and ${ABMax}.`
            },
            {
                value: firstSix,
                min: sixMin,
                max: sixMax,
                condition: firstSix > 0,
                message: `First Six bet must be between ${sixMin} and ${sixMax}.`
            },
            {
                value: lastSix,
                min: sixMin,
                max: sixMax,
                condition: lastSix > 0,
                message: `Last Six bet must be between ${sixMin} and ${sixMax}.`
            },
            {
                value: suit,
                min: suitsMin,
                max: suitsMax,
                condition: suit > 0,
                message: `Suit bet must be between ${suitsMin} and ${suitsMax}.`
            },
            {
                value: betToValidate,
                min: totalMin,
                max: totalMax,
                condition: betToValidate > 0,
                message: `Total bet must be between ${totalMin} and ${totalMax}.`
            },
            {
                value: betToValidate,
                max: balance,
                condition: betToValidate > 0,
                message: `Insufficient balance. You only have ${balance}.`
            }
        ];

        const invalidRule = rules.find(rule => {
            if (!rule.condition) return false;
            if (rule.min !== undefined && rule.value < rule.min) return true;
            if (rule.max !== undefined && rule.value > rule.max) return true;
            return false;
        });

        if (invalidRule) {
            setInfoMsg(invalidRule.message);
            setShowInfoPopUp(true);
            return false;
        }

        return true;
    };


    const placeBetOnCards = (cardNumber) => {
        let betOnCard = { ...cardsBet }
        let newbet = {}
        let newBetAmount = changeAmountToFixed(((Object.values(betOnCard)[0] ?? 0) + betChipsArray[selectedBetChip]), 2)
        newbet[cardNumber] = newBetAmount
        //  console.log(newBetAmount, newbet);

        if (checkIfTheBetAmountIsValid(newBetAmount)) {
            setCardsBet({ ...newbet })
        }
    }

    const placeBet = (betIsPlaceOn, passToChild) => {
        if (isBetSent) {
            return
        }

        if (props.andarBaharTimerResult.action === "ANDAR_BAHAR_BET") {
            setShowWinAnimation(false)
            setWinResult(undefined)
            cardContainerRef.current?.setAB_Bets(false)
            cardContainerRef.current?.setIsDealt(false)
            cardContainerRef.current?.clearAllCards()
        }

        switch (betIsPlaceOn) {
            case "rankCards": if (disableBets && !cardContainerRef.current?.disableAB_Bets) {
                setInfoMsg("Place Your Bets on Andar Or Bahar")
                setShowInfoPopUp(true);
                return
            }
                placeBetOnCards(passToChild); break;
            case "andar":
                if (!disableBets && cardContainerRef.current?.disableAB_Bets) {
                    setInfoMsg("Place Your Bets on Rank Cards, Suits and Dozens!!!")
                    setShowInfoPopUp(true);
                    return
                }
                let andar = changeAmountToFixed(Number(andarBet + betChipsArray[selectedBetChip]), 2)
                if (checkIfTheBetAmountIsValid(undefined, andar)) {
                    // removeWinAnimations()
                    setAndarBet(andar)
                };
                break;
            case "bahar":
                if (!disableBets && cardContainerRef.current?.disableAB_Bets) {
                    setInfoMsg("Place Your Bets on Rank Cards, Suits and Dozens!!!")
                    setShowInfoPopUp(true);
                    return
                }
                let bahar = changeAmountToFixed(Number(baharBet + betChipsArray[selectedBetChip]), 2)
                if (checkIfTheBetAmountIsValid(undefined, undefined, bahar)) {
                    // removeWinAnimations()
                    setBaharBet(bahar)
                };
                break;
            case "suits":
                if (disableBets && !cardContainerRef.current?.disableAB_Bets) {
                    setInfoMsg("Place Your Bets on Andar Or Bahar")
                    setShowInfoPopUp(true);
                    return
                }
                placeBetsOnSuit(passToChild); break;
            case "firstSixBet":
                if (disableBets && !cardContainerRef.current?.disableAB_Bets) {
                    setInfoMsg("Place Your Bets on Andar Or Bahar")
                    setShowInfoPopUp(true);
                    return
                }
                let firstSix = changeAmountToFixed(Number(firstSixBet + betChipsArray[selectedBetChip]), 2)
                if (checkIfTheBetAmountIsValid(undefined, undefined, undefined, undefined, firstSix)) {
                    setFirstSixBet(firstSix)
                }
                break;
            case "lastSixBet":
                if (disableBets && !cardContainerRef.current?.disableAB_Bets) {
                    setInfoMsg("Place Your Bets on Andar Or Bahar")
                    setShowInfoPopUp(true);
                    return
                }
                let lastSix = changeAmountToFixed(Number(lastSixBet + betChipsArray[selectedBetChip]), 2)
                if (checkIfTheBetAmountIsValid(undefined, undefined, undefined, undefined, undefined, lastSix)) {
                    setLastSixBet(lastSix)
                }
                break;
            default: break;
        }
    }

    const clearAllBets = () => {
        if (isBetSent) {
            return
        }
        if ((props.gameState.handId !== props.gameState.oldHandId && !props.andarBaharTimerResult?.action) || props.andarBaharTimerResult?.action === "ANDAR_BAHAR_BET") {
            setAndarBet(0)
            setBaharBet(0)
            setCardsBet({})
            setSuitBets({
                spade: 0,
                club: 0,
                diamond: 0,
                heart: 0
            })
            setFirstSixBet(0)
            setLastSixBet(0)
        } else if (props.andarBaharTimerResult?.action === "PARAM_BET" || (props.gameState.handId === props.gameState.oldHandId && !props.andarBaharTimerResult?.action)) {
            setAndarBet(0)
            setBaharBet(0)
        }
    }

    const doubleFn = () => {
        if (isBetSent) {
            return
        }

        const balance = Number(props.balance);

        // Extract limits
        const [rankMin, rankMax] = betLimits[0].split("-").map(Number);
        const [suitMin, suitMax] = betLimits[1].split("-").map(Number);
        const [sixMin, sixMax] = betLimits[2].split("-").map(Number);
        const [ABMin, ABMax] = betLimits[3].split("-").map(Number);

        const totalMin = Number(props.minBetAmt);
        const totalMax = Number(props.maxBetAmt);

        // ===== Helper: validate only one bet =====
        const isValidSingleBet = (value, min, max) => {
            if (value <= 0) return true; // 0 is allowed
            return value >= min && value <= max;
        };

        // ===== Clone current values =====
        let updatedCards = { ...cardsBet };
        let updatedSuits = { ...suitBets };
        let updatedAndar = andarBet;
        let updatedBahar = baharBet;
        let updatedFirstSix = firstSixBet;
        let updatedLastSix = lastSixBet;

        let hasAnyValidDouble = false;


        if (props.andarBaharTimerResult?.action === "PARAM_BET" || (!props.andarBaharTimerResult?.action && props.gameState.handId === props.gameState.oldHandId)) {
            // ===== 3️⃣ Andar =====
            if (isValidSingleBet(andarBet * 2, ABMin, ABMax)) {
                updatedAndar = andarBet * 2;
                hasAnyValidDouble = true;
            }

            // ===== 4️⃣ Bahar =====
            if (isValidSingleBet(baharBet * 2, ABMin, ABMax)) {
                updatedBahar = baharBet * 2;
                hasAnyValidDouble = true;
            }
        } else {
            // ===== 1️⃣ Rank Cards =====
            Object.keys(updatedCards).forEach(card => {
                const doubled = updatedCards[card] * 2;

                if (isValidSingleBet(doubled, rankMin, rankMax)) {
                    updatedCards[card] = doubled;
                    hasAnyValidDouble = true;
                }
            });

            // ===== 2️⃣ Suit Bets =====
            Object.keys(updatedSuits).forEach(suit => {
                const doubled = updatedSuits[suit] * 2;

                if (isValidSingleBet(doubled, suitMin, suitMax)) {
                    updatedSuits[suit] = doubled;
                    hasAnyValidDouble = true;
                }
            });
            // ===== 5️⃣ First Six =====
            if (isValidSingleBet(firstSixBet * 2, sixMin, sixMax)) {
                updatedFirstSix = firstSixBet * 2;
                hasAnyValidDouble = true;
            }

            // ===== 6️⃣ Last Six =====
            if (isValidSingleBet(lastSixBet * 2, sixMin, sixMax)) {
                updatedLastSix = lastSixBet * 2;
                hasAnyValidDouble = true;
            }
        }



        // ❌ If NOTHING could be doubled → throw error
        if (!hasAnyValidDouble) {
            setInfoMsg("Maximum bet limits reached.");
            setShowInfoPopUp(true);
            return;
        }

        // ===== 7️⃣ Calculate New Final Total =====
        const finalTotal =
            Object.values(updatedCards).reduce((a, b) => a + b, 0) +
            Object.values(updatedSuits).reduce((a, b) => a + b, 0) +
            updatedAndar +
            updatedBahar +
            updatedFirstSix +
            updatedLastSix;

        // ❌ Rule: Cannot exceed balance
        if (finalTotal > balance) {
            setInfoMsg(`Insufficient balance. You only have ${balance}.`);
            setShowInfoPopUp(true);
            return;
        }

        // ❌ Rule: Cannot exceed total max bet
        if (finalTotal > totalMax) {
            setInfoMsg(`Total bet cannot exceed ${totalMax}.`);
            setShowInfoPopUp(true);
            return;
        }

        // ❌ Rule: Must be above minimum
        if (finalTotal < totalMin) {
            setInfoMsg(`Total bet must be at least ${totalMin}.`);
            setShowInfoPopUp(true);
            return;
        }

        // ===== 8️⃣ Apply doubled values =====
        if (props.andarBaharTimerResult?.action === "ANDAR_BAHAR_BET" || (!props.andarBaharTimerResult?.action && props.gameState.handId !== props.gameState.oldHandId)) {
            setCardsBet(updatedCards);
            setSuitBets(updatedSuits);
            setFirstSixBet(changeAmountToFixed(updatedFirstSix, 2));
            setLastSixBet(changeAmountToFixed(updatedLastSix, 2));
        } else {
            setAndarBet(changeAmountToFixed(updatedAndar, 2));
            setBaharBet(changeAmountToFixed(updatedBahar, 2));
        }
    };




    const betFn = (betType) => {
        switch (betType) {
            case props.language.Prev: setPreviousBetAmount(); break;
            case props.language.BetOK: cardContainerRef?.current?.isDealt ? sendAndarBaharBetRequest() : sendBetRequest(); break;
            default: break;
        }
    }

    const setPreviousBetAmount = () => {
        if (isBetSent) return;

        setShowWinAnimation(false)
        setWinResult(undefined)
        if (props.andarBaharTimerResult.action === "ANDAR_BAHAR_BET") {
            cardContainerRef.current?.setIsDealt(false)
            cardContainerRef.current?.clearAllCards()
        }

        const prevBetString = props.gameState?.betRequest?.betString;
        if (!prevBetString) return;

        const [
            rankPart,
            suitPart,
            sixPart,
            abPart
        ] = prevBetString.split(",");

        // --------------------------
        // 1️⃣ Parse previous bets
        // --------------------------

        // Rank
        const rankArr = rankPart.split("|");
        const rankIndex = rankArr.findIndex(v => Number(v) > 0);
        const rankBet = rankIndex >= 0 ? changeAmountToFixed(rankArr[rankIndex], 2) : 0;

        // Suits
        const [spade, club, diamond, heart] = suitPart.split("|");
        const suitBetsObj = {
            spade: changeAmountToFixed(spade, 2),
            club: changeAmountToFixed(club, 2),
            diamond: changeAmountToFixed(diamond, 2),
            heart: changeAmountToFixed(heart, 2)
        };
        const suitBetTotal =
            Number(spade) + Number(club) + Number(diamond) + Number(heart);

        // FirstSix / LastSix
        const [firstSixRaw, lastSixRaw] = sixPart.split("|");
        const firstSix = changeAmountToFixed(firstSixRaw, 2);
        const lastSix = changeAmountToFixed(lastSixRaw, 2);

        // Andar / Bahar
        const [andarRaw, baharRaw] = abPart.split("|");
        const andar = changeAmountToFixed(andarRaw, 2);
        const bahar = changeAmountToFixed(baharRaw, 2);

        // --------------------------
        // 2️⃣ Balance check (combined)
        // --------------------------
        const balance = Number(props.balance);
        const totalBet =
            Number(rankBet) +
            Number(suitBetTotal) +
            Number(firstSix) +
            Number(lastSix) +
            Number(andar) +
            Number(bahar);

        if (totalBet > balance) {
            setInfoMsg(`Insufficient balance to restore previous bets. You have only ${balance}.`);
            setShowInfoPopUp(true);
            return;
        }

        // --------------------------
        // 3️⃣ Validate bets using SAME PLACE BET rules
        // --------------------------
        const isValid = checkIfTheBetAmountIsValid(
            rankBet,
            andar,
            bahar,
            0,
            firstSix,
            lastSix,
            suitBetTotal
        );

        if (!isValid) {
            //  console.log("Previous bet invalid → skipping apply.");
            return;
        }

        // --------------------------
        // 4️⃣ Apply ONLY allowed bets based on new rules
        // --------------------------

        const canSetHighBets = !disableBets;
        const canSetAB = disableBets;

        // 4.1️⃣ Rank, Suits, FirstSix, LastSix
        if (canSetHighBets) {
            //  console.log("Applying: Rank, Suits, FirstSix, LastSix");

            // Rank
            setCardsBet(() => {
                if (rankIndex >= 0) return { [rankIndex]: rankBet };
                return {};
            });

            // Suits
            setSuitBets(() => ({ ...suitBetsObj }));

            // First six / Last six
            setFirstSixBet(() => firstSix);
            setLastSixBet(() => lastSix);
        }
        // else {
        //  console.log("Skipping Rank/Suits/FirstSix/LastSix because disableBets = true");
        // }

        // 4.2️⃣ Andar / Bahar
        if (canSetAB) {
            //  console.log("Applying: Andar/Bahar");
            setAndarBet(() => andar);
            setBaharBet(() => bahar);
        }
        // else {
        //  console.log("Skipping Andar/Bahar because disableBets or disableAB_Bets is true");
        // }

        // Button update
        setBetBtn(props.language.BetOK);
    };


    const placeBetsOnSuit = (suit) => {
        let newSuitBet = changeAmountToFixed(Number(suitBets[suit]) + Number(betChipsArray[selectedBetChip]), 2)
        if (checkIfTheBetAmountIsValid(undefined, undefined, undefined, newSuitBet)) {
            setSuitBets(prev => ({ ...prev, [suit]: newSuitBet }))
        }
    }

    const sendBetRequest = () => {
        let res = {
            andharCards: ["AS", "10D", "7S", "8D", "KC", "QD", "10H", "9S"],
            baharCards: ["2C", "2D", "4D", "9C", "QS", "JH", "10H", "6S"]
        }

        let body = {
            "sessionId": sessionStorage.getItem("sessionId"),
            "CN": "ANDAR_BAHAR_CLASSIC_NON_TIMER_BET",
            "object": {
                "gameId": 42,
                "playerId": props.playerId,
                "betAmount": Number(betAmount) - Number(andarBet) - Number(baharBet),
                "action": "PARAM_BET",
                "handId": Number(props.gameState.handId),
                "betString": `${Array(13).fill(0).map((ele, idx) => cardsBet[idx] || "0").join("|")},${suitBets.spade}|${suitBets.club}|${suitBets.diamond}|${suitBets.heart},${firstSixBet}|${lastSixBet}`
            },
        }
        betRequestTimeOut.current = setTimeout(() => {
            if (betRequestTimeOut.current) {
                props.showTimeOut("Re-Connecting......!\n Please Click on Refresh");
                betRequestTimeOut.current = null;
            }
        }, 5000);
        setDisableBets(true)
        setIsBetSent(true)
        setInfoMsg(props.language.Bet_Processing_Msg)
        playTheSound("buttonClick")
        props.network?.sendof(body)
        // cardContainerRef.current.startDealingCards(res)
    }

    const sendAndarBaharBetRequest = () => {
        let body = {
            "sessionId": sessionStorage.getItem("sessionId"),
            "CN": "ANDAR_BAHAR_CLASSIC_NON_TIMER_BET",
            "object": {
                "gameId": 42,
                "playerId": props.playerId,
                "betAmount": Number(andarBet) + Number(baharBet),
                "action": "ANDAR_BAHAR_BET",
                "handId": Number(props.gameState.handId),
                "betString": `${andarBet}|${baharBet}`
            },
        }
        betRequestTimeOut.current = setTimeout(() => {
            if (betRequestTimeOut.current) {
                props.showTimeOut("Re-Connecting......!\n Please Click on Refresh");
                betRequestTimeOut.current = null;
            }
        }, 5000);
        setDisableBets(true)
        setIsBetSent(true)
        setInfoMsg(props.language.Bet_Processing_Msg)
        playTheSound("buttonClick")
        props.network?.sendof(body)
    }

    const addWinAnimationGlow = () => {
        setShowWinAnimation(true)
        if (props.andarBaharTimerResult.action === "PARAM_BET") {
            const [cardRank, cardSuit, sixSet] = props.andarBaharTimerResult?.winData
            setWinResult({
                rankCard: cardRank,
                suitBet: cardSuit,
                sixSet,
            })
            setIsBetSent(false)
        } else if (props.andarBaharTimerResult.action === "ANDAR_BAHAR_BET" && props.andarBaharTimerResult.handId === props.gameState.handId) {
            console.log(props.andarBaharTimerResult.handId === props.gameState.handId);

            // const AB = props.andarBaharTimerResult?.winData[3]
            // setWinResult({
            //     AB_Win: AB
            // })
            const [cardRank, cardSuit, sixSet, AB] = props.andarBaharTimerResult?.winData
            setWinResult({
                rankCard: cardRank,
                suitBet: cardSuit,
                sixSet,
                AB_Win: AB
            })

            if (props.andarBaharTimerResult.totalWinAmount) {
                setSafeTimeout(() => {
                    setWinAmount(props.andarBaharTimerResult.totalWinAmount)
                    setShowWinAmount(true)
                    setInfoMsg(props.andarBaharTimerResult.message)
                }, 3000)
            } else {
                setSafeTimeout(() => {
                    getGameStatePlayerBalance()
                }, 3000)
            }
        }
    }

    const removeWinAnimations = () => {
        setWinAmount(0)
        if (props.andarBaharTimerResult.action === "ANDAR_BAHAR_BET") {
            // setDisableBets(false)
            setShowWinAmount(false)
            setInfoMsg("Place Your Bets on Andar Or Bahar")
            getGameStatePlayerBalance()
        } else {
            setIsBetSent(false)
        }
    }

    const playTheSound = (sound) => {
        soundsRef?.current[sound]?.stop()
        soundsRef?.current[sound]?.play()
    }

    const updateHistory = (res) => {
        //  console.log(res)
    }

    const getGameStatePlayerBalance = () => {
        props.playerBalanceHandle()
        props.gamstateHandle()
    }

    return (<div id="andarBaharClassicGameBox" className={`${orientation}_ABC`}>
        <img className="ABC_NT_i_icon" src={infoIcon_img} onClick={() => { !isBetSent && setShowGameRules(true) }} />
        <div id="ABC_NT_Title">
            <img className="ABC_NT_titleImages" src={AndarTitleImg}></img>
            <img className="ABC_NT_titleImages" src={BaharTitleImg}></img>
        </div>
        <div id="userEssentials">
            <div className="detailBox" id="balance">{props.language.Balance}: {changeAmountToFixed((props.balance - duplicateBetAmount), 2)}</div>
            <div className="detailBox" id="winAmount">{props.language.Wins}: {winAmount}</div>
            <div id="playerDetails"></div>
        </div>
        {/* {showInfoPopUp &&  */}
        <div id="ABC_NT_info_popup" className={showInfoPopUp ? "moveTheElements" : ""} >
            <span id="popUp_msg">{infoMsg}</span>
            <span id="shootinStar"></span>
        </div>
        {/* } */}
        {Boolean(infoMsg) && <div id="ABC_NT_info_container">
            <div id="ABC_NT_info_box">{infoMsg}</div>
        </div>}
        <div className="ABC_NT_PlayerDetails">
            <div className="ABC_NT_playerInfo ABC_NT_playerName">{props.user}</div>
            <div className="ABC_NT_playerInfo ABC_NT_playerId"><b>Player Id: </b>{props.playerId}</div>
            <div className="ABC_NT_playerInfo ABC_NT_handId"><b>Hand Id: </b>{props.gameState.handId}</div>
        </div>
        {Boolean(props.gameState?.history.length) && <div className="ABC_NT_History_box">
            {props.gameState?.history?.map((ele, ind) => <div key={ele} className="ABC_NT_history">
                <Card cardTitle={ele.result?.joker} newClassName={"ABC_NT_history_card"} ></Card>
                <p className="ABC_NT_history_result">{ele.result?.winner}</p>
            </div>)}
        </div>}
        <AndarBaharCardContainer ref={cardContainerRef} placeBet={placeBet} cardsBet={cardsBet} selectedBetChip={selectedBetChip} abt_chipValues={props.abt_chipValues} andarBet={andarBet} baharBet={baharBet} suitBets={suitBets} firstSixBet={firstSixBet} lastSixBet={lastSixBet} winResult={winResult} showWinAnimation={showWinAnimation} playTheSound={playTheSound} setWinGlow={addWinAnimationGlow} gameResult={props.andarBaharTimerResult} disableBets={disableBets} isInitial={isInitial.current} setInfoMsg={setInfoMsg}></AndarBaharCardContainer>
        <AndarBaharClassicChipsController ref={controllerRef} language={props.language} abt_chipValues={props.abt_chipValues} selectedBetChip={selectedBetChip} setSelectedBetChip={setSelectedBetChip} betAmount={betAmount} clearAllBets={clearAllBets} doubleFn={doubleFn} betFn={betFn} betBtn={betBtn} disableBets={disableBets} isBetSent={isBetSent} disableBetBtn={disableBetBtn}></AndarBaharClassicChipsController>
        {Boolean(showWinAmount) && <CardSparkAnimation winAmount={winAmount} onAnimationEnd={removeWinAnimations}></CardSparkAnimation>}
        {showGameRules && <AndarBaharClassicNonTimerInfo
            payoutInfo={props.game_PayoutInfo}
            minBetAmt={props.minBetAmt}
            maxBetAmt={props.maxBetAmt}
            innerLimits={props.abt_innerLimits}
            closePopup={() => setShowGameRules(false)}
        ></AndarBaharClassicNonTimerInfo>}
        {enterPopUp && <div className="iosFetchSounds" id="iospopup" onClick={(e) => setEnterPopUp(false)}>
            <div className="popupTooLong">
                <div className="mt-2">{props.language.Wel_ABC_NT}</div>
                {props.language?.OK_Btn}
                <br></br>
                <br></br>
                <div className="fd">
                    <button className="btn_iosPopup"> OK </button>
                    <br></br>
                </div>
            </div>
        </div>}
    </div>)
})

export default AndarBaharClassic